/* Ivellora PDP final: delivery dates and lightweight accordion polish. */
(function () {
  function parseDayRange(value, fallback) {
    const matches = String(value || '').match(/\d+/g);
    if (!matches || matches.length === 0) return fallback;
    const values = matches.map(Number).filter(Number.isFinite);
    return values.length ? { min: values[0], max: values[1] || values[0] } : fallback;
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + Math.max(0, days));
    return result;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(date);
  }

  function initTimeline(root) {
    root.querySelectorAll('[data-ivellora-delivery-timeline]').forEach((timeline) => {
      if (timeline.dataset.ivelloraFinalReady === 'true') return;
      timeline.dataset.ivelloraFinalReady = 'true';

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const processing = parseDayRange(timeline.dataset.processingTime, { min: 7, max: 10 });
      const total = parseDayRange(timeline.dataset.totalTime, { min: 14, max: 18 });
      const order = timeline.querySelector('[data-ivellora-order-date]');
      const made = timeline.querySelector('[data-ivellora-made-date]');
      const delivered = timeline.querySelector('[data-ivellora-delivered-date]');

      const madeStart = addDays(today, processing.min);
      const madeEnd = addDays(today, processing.max);
      const deliveryStart = addDays(today, total.min);
      const deliveryEnd = addDays(today, total.max);

      if (order) order.textContent = formatDate(today);
      if (made) made.textContent = `${formatDate(madeStart)}–${formatDate(madeEnd)}`;
      if (delivered) delivered.textContent = `${formatDate(deliveryStart)}–${formatDate(deliveryEnd)}`;
    });
  }

  function initAccordions(root) {
    root.querySelectorAll('.ivellora-product-description-accordion, .yuanqi-product-accordion').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });
  }

  function init(root) {
    initTimeline(root);
    initAccordions(root);
  }

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
